<template>
	<div>
		<template v-if="line">
			<div class="line bottom"></div>
		</template>

		<template v-if="angle">
			<img class="angle left-top" v-if="leftTop" src="../../assets/image/icon_angle_left_top.png">
			<img class="angle left-bottom" v-if="leftBottom" src="../../assets/image/icon_angle_left_bottom.png">
			<img class="angle right-top" v-if="rightTop" src="../../assets/image/icon_angle_right_top.png">
			<img class="angle right-bottom" v-if="rightBottom" src="../../assets/image/icon_angle_right_bottom.png">
		</template>
	</div>
</template>

<script>
export default {
	props: {
		line: {
			type: Boolean,
			default: false
		},
		angle: {
			type: Boolean,
			default: false
		},
		leftTop: {
			type: Boolean,
			default: false
		},
		leftBottom: {
			type: Boolean,
			default: false
		},
		rightTop: {
			type: Boolean,
			default: false
		},
		rightBottom: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
@import "../../style/_parameter.scss";
.line{
	position: absolute;
	//background: #90D6FF;
	//box-shadow: 0 0 13px rgba(80,166,255,.54);
	&.bottom{
		width: 100%;
		height: 6px;
		left: 0;
		bottom: 0;
	}
}
.angle{
	position: absolute;
	width: 36px;
	height: 36px;
	&.left-top{
		top: 0;
		left: 0;
	}
	&.left-bottom{
		bottom: 0;
		left: 0;
	}
	&.right-top{
		top: 0;
		right: 0;
	}
	&.right-bottom{
		bottom: 0;
		right: 0;
	}
}
</style>
